import i18n from '@/i18n';

const PageDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/pages/dashboardDispatcher/Dashboard.vue'
  );
const Filters = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/pages/dashboardDispatcher/filters'
  );
const DashboardTop = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/pages/dashboardDispatcher/DashboardTop.vue'
  );

export const REQUESTS_DASHBOARD_DISPATCHER_ROUTE_NAME =
  'requests-dashboard-dispatcher';

export default {
  getDashboardDispatcherRoute() {
    return {
      path: 'dashboardDispatcher',
      name: REQUESTS_DASHBOARD_DISPATCHER_ROUTE_NAME,
      components: {
        default: PageDashboard,
        top: DashboardTop,
        'right-drawer': Filters,
      },
      meta: {
        authorizations: ['isMy360'],
        isHidden: false,
        title: 'dashboardDispatcher',
        icon: i18n.t('message.dashboardDispatcher.icon'),
      },
    };
  },
};
